// Note templates for the Additional Notes box on the buyers agreement pricing tab.
//
// A frontend constant rather than reference data, deliberately: the backend never needs to know a
// template exists. Choosing one only pastes text into `retailAgreementNotes`, which is already
// saved with the deal and already printed on both documents, so there is no API, DTO or database
// surface to add. A NoteTemplate table would mean an entity, a mapping, a HiLo seed, a repository,
// an endpoint and an admin screen for what is currently one paragraph of legal copy.
//
// Templates come from Ferrari North America and change rarely — "every now and then, Ferrari enters
// new terms for a certain order" (Garrett, 2026-09-16). Adding one is appending an object here. If
// they ever need per-dealer scoping or editing by a user rather than a developer, this { id, name,
// text } shape maps straight onto a config entity at that point.
//
// `text` is legal copy: byte-exact, do NOT reflow or re-wrap it. It is built from an array joined
// with blank lines rather than a template literal so that editor indentation can never leak into
// the document. The blank lines survive to the PDF as paragraph breaks via
// MakeDocumentSafe(value, true) in DealDocumentService.
//
// Length note: the textarea carries maxlength="2000", but that only constrains typing — a
// programmatic v-model assignment is not truncated by it, and Deal.retail_agreement_notes is ntext
// with no length limit. A template longer than 2000 characters would therefore apply and save in
// full while being impossible to type. Decide whether to raise the textarea cap before adding one.
// Today's single template is 869 characters.
export const NOTE_TEMPLATES = Object.freeze([
  Object.freeze({
    id: 1,
    name: '12 Cilindri Manuale — Allocation Terms',
    text: [
      'Dealer and/or Ferrari North America (FNA) will remain fully entitled to cancel the allocation of the ordered Ferrari 12 Cilindri Manuale in case:',
      'A. You (i) do not comply with the provisions of this Agreement (or any other applicable Dealer or FNA policies or agreements) in place with you concerning Ferrari vehicles (including, but not limited to, ROFR agreements regarding any Ferrari vehicles); and/or (ii) you are found to manage a business activity as a car reseller;',
      'B. You reduce the number of Ferrari vehicles you own as of July 21, 2026, as shown in Ferrari’s E-CRM system, such that, at the time of delivery of the subject vehicle, You own fewer Ferrari vehicles than were owned by You on July 21, 2026; or',
      'C. any of the instructions or policies set by FNA regarding the sales process of the Ferrari 12 Cilindri Manuale vehicle are not correctly followed.'
    ].join('\n\n')
  })
])
